export const tabConfig = [
  {
    name: 'trial',
    displayName: '我的陪审',
    className: 'icon_my_trial'
  },
  {
    name: 'signed',
    displayName: '陪审签到',
    className: 'icon_trial_sign'
  },
  {
    name: 'announcement',
    displayName: '通知公告',
    className: 'icon_notice'
  },
  {
    name: 'my',
    displayName: '个人中心',
    className: 'icon_personal'
  }
]



// WEBPACK FOOTER //
// ./src/views/juror/layout/config.js